import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import VisibilitySensor from 'react-visibility-sensor';
import Analytics from '@com/core/common/utils/analytics';
import { AppContext } from '@com/core/common/contexts/appContext';
import { breakpoints } from '@com/core/common/styles/baseStyles';

import { TBannerModule, TModuleGroup } from '@com/core/common/types/catalog';

import ComponentArea from './componentArea';
import ComponentRow from './componentRow';
// import ComponentColumn from './componentColumn';
import StaticComponent from '../staticComponent';
import StaticNavigation from '../staticNavigation/staticNavigation';

/* -------------------------------------> 1. COMPONENT AREAS/ROWS */

type TProps = {
    components: TModuleGroup[];
    canonicalUrl: string;
    usage?: 'partial' | 'full'; // e.g. in cart or plp compared to a full static page
};

// TODO: Update this to include viewport tracking
const doTrackImpression = (locale, c: TModuleGroup): void => {
    const flatten = (arr: any[]): any[] => [].concat(...arr);
    try {
        const { modules } = c;
        const moduleGapt =
            modules &&
            modules.map(componentModule => {
                const { banners } = componentModule as TBannerModule;
                if (banners) {
                    const gapt = banners.map(banner => {
                        if (banner.gapt) {
                            return { id: banner.gapt.name, name: banner.gapt.name, position: banner.gapt.position };
                        }
                        return null;
                    });

                    return flatten(gapt);
                }
                return null;
            });
        // return flatten(moduleGapt);

        // Get rid of nulls
        const filteredGapts = flatten(flatten(moduleGapt)).filter(
            (x: { id: string; name: string; position: string }): { id: string; name: string; position: string } => x,
        );
        if (!!filteredGapts && filteredGapts.length) {
            Analytics.trackImpression(locale, {
                ecommerce: {
                    promoView: {
                        promotions: filteredGapts,
                    },
                },
                platform: 'web',
            });
        }
    } catch (e) {
        // Ignore
    }
};

const ComponentsRender = ({ canonicalUrl, components, usage }: TProps): JSX.Element => {
    const { locale } = useContext(AppContext);
    useEffect(() => {
        try {
            // doTrackImpression(locale, components);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [canonicalUrl, components]);

    let staticNavComponent = null;
    const otherComponents = components
        .map(component => {
            if (Array.isArray(component.modules)) {
                if (component.modules[0].type !== 'staticNavigation') {
                    return component;
                }
                if (component.modules[0].type === 'staticNavigation') {
                    [staticNavComponent] = component.modules;
                }
            }
            // if (component.sectionLayout === 'columns' && Array.isArray(component.columns)) {
            //     return component;
            // }
            return null;
        })
        .filter(x => x) as TModuleGroup[];

    const onChange = (isVisible: boolean, componentArea) => {
        if (isVisible && componentArea) {
            doTrackImpression(locale, componentArea);
        }
    };

    /* eslint-disable react/no-array-index-key */
    // No reliable unique key for module or component, could use uuid
    const renderComponents = otherComponents.map((componentArea, areaIndex) => {
        // if (componentArea.sectionLayout === 'columns' && Array.isArray(componentArea.columns)) {
        //     return (
        //         <ComponentArea key={areaIndex} componentArea={componentArea}>
        //             <div style={{ display: 'flex' }}>
        //                 {componentArea.columns.map((column, columnIndex) => (
        //                     <ComponentColumn key={columnIndex}>
        //                         {column.modules.map((component, moduleIndex) => (
        //                             <ComponentRow key={moduleIndex} outerSpacing={component.outerSpacing}>
        //                                 <StaticComponent key={moduleIndex} component={component} />
        //                             </ComponentRow>
        //                         ))}
        //                     </ComponentColumn>
        //                 ))}
        //             </div>
        //         </ComponentArea>
        //     );
        // }
        return (
            <VisibilitySensor onChange={isVisible => onChange(isVisible, componentArea)} key={areaIndex}>
                <ComponentArea key={areaIndex} componentArea={componentArea}>
                    {componentArea.modules.map((component, index) => {
                        return (
                            <ComponentRow
                                key={index}
                                outerSpacing={component.outerSpacing}
                                textColor={component.textColor}>
                                <StaticComponent component={component} />
                            </ComponentRow>
                        );
                    })}
                </ComponentArea>
            </VisibilitySensor>
        );
    });
    /* eslint-enable react/no-array-index-key */
    if (usage === 'partial') {
        return <PartialContainer>{renderComponents}</PartialContainer>;
    }
    return (
        <Container>
            <div className="pageComponents">{renderComponents}</div>
            {staticNavComponent && <StaticNavigation moduleData={staticNavComponent} />}
        </Container>
    );
};

const Container = styled.div`
    @media ${breakpoints.minDesktop} {
        display: flex; /* components > static nav */
        flex-direction: row-reverse;
        max-width: 1440px;
        margin: 0 auto;
        background-color: ${({ theme }): string => theme.colors.bgPrimary};

        .pageComponents {
            flex: 1;
            min-width: 0;
        }
    }
`;

const PartialContainer = styled.div`
    .siteWidthContainer {
        padding: 0;
        min-width: 0;
    }
`;

export default ComponentsRender;
